import { graphql } from "react-apollo";
import { EDIT_REGION_COMMENT } from "../../graphql/mutations";

export default graphql(EDIT_REGION_COMMENT, { name: "editRegionComment" });
